import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { GetPlanMasterByIdResponse, PlanAddonsResponse } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { catchError, map, Observable, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';


@Injectable({
  providedIn: 'root'
})
export class PlanmasterService {
  private http = inject(HttpClient);
  private route = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  getSubscriptionPlanService(tenantId: number,allParams: Array<any>= []): Observable<any> {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {
       parsedParams = parsedParams.append(p.paramName, p.paramValue);
     });
    }
    
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.GET_SUBSCRIPTION_PLANS
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, {headers: this.httpOptions.headers , params: parsedParams})
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSubscriptionPlanServiceById(tenantId: number, subscription_planId: number): Observable<GetPlanMasterByIdResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.GET_SUBSCRIPTION_PLAN_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{plan_id}', subscription_planId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSubscriptionAddonsByPlanId(tenantId: number, subscription_planId: number): Observable<PlanAddonsResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.PLAN.GET_PLAN_ELIGIBLE_ADDONS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{plan_id}', subscription_planId.toString());
    return this.http.get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCompanyLevelPlans(): Observable<any> {
    return this.http.get(environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_SUBSCRIPTION_PLANS, this.httpOptions).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getFranchiseGroupSubscriptionPlans(franchiseGroupId: number): Observable<{ items?: { plan_name?: string }[] }> {
    const url =
      environment.BASE_URL +
      CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_SUBSCRIPTION_PLANS.replace(
        '{franchise_group_id}',
        franchiseGroupId.toString()
      );
    return this.http.get(url, this.httpOptions).pipe(
      map((res: unknown) => res as { items?: { plan_name?: string }[] }),
      catchError((error: Response) => throwError(() => new AppErrors(error)))
    );
  }


  getProducts(tenantId: number, allParams: Array<any> = []): Observable<any> {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {
       parsedParams = parsedParams.append(p.paramName, p.paramValue);
     });
    }
    
    return this.http.get(environment.RETAIL_BILLING_URL + CONST_URL_SEGEMENTS.RETAIL_PRODUCTS.GET_RETAIL_PRODUCT_SKUS
      .replace('{tenant_id}', tenantId.toString()), {headers: this.httpOptions.headers , params: parsedParams})
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  } 
  

} 
